import React from 'react'
import * as Sentry from '@sentry/nextjs'

type ErrorBoundaryProps = {
  viewId: string
  children: React.ReactNode
}

type ErrorBoundaryState = {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = {
      hasError: false
    }
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true }
  }

  componentDidCatch(error: any, errorInfo: any) {
    // Keep the viewId in Sentry (for triage) but never render it — the old
    // dev string leaked an internal identifier into the UI.
    Sentry.captureException(error, { extra: { ...errorInfo, viewId: this.props.viewId } })
  }

  render() {
    if (this.state.hasError) {
      // Degrade this actor's section only, silently — the rest of the scene
      // keeps rendering (each actor has its own boundary).
      return null
    }

    return this.props.children
  }
}